<div class="map-wrapper w-100" [style]="mapContainerStyles()">
  <div class="map-container" #mapContainer id="mapContainer"></div>
  @if (imageUrl()) {
    <div class="map-controls">
      <button class="zoom-control zoom-in" (click)="zoomIn()">+</button>
      <button class="zoom-control zoom-out" (click)="zoomOut()">-</button>
    </div>
    <div class="map-attribution">Leaflet</div>
  }
</div>

<!-- Mapping Popup -->
<app-mapping-popup
  [visible]="showMappingPopup && !_projectService.disabled()"
  [coordinates]="clickedCoordinates"
  [lots]="availableLots()"
  (pointSaved)="onPointSaved()"
  (pointCancelled)="onPointCancelled()"
>
</app-mapping-popup>
